import { render, staticRenderFns } from "./orderDownloadOrderDialog.vue?vue&type=template&id=ba2f2740"
import script from "./orderDownloadOrderDialog.vue?vue&type=script&lang=js"
export * from "./orderDownloadOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDownloadOrderDialog.vue?vue&type=style&index=0&id=ba2f2740&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports